(ns web3.components.h-slider
  (:require [reagent.core :as r]))

(def h-slider
  (r/create-class
   {:component-will-receive-props
    (fn [{:keys [state props] :as this} [_ {next-content :content
                                            next-key :content/key
                                            next-index :index
                                            :as next-props}]]
      (let [{prev-content :content
             prev-key :content/key
             prev-index :index
             :as prev-props} props]
        (when (not= prev-key next-key)
          (swap! state merge
                 {:changing? true
                  :enter-from (when prev-index
                                (cond (< next-index prev-index) :left
                                      (> next-index prev-index) :right))
                  :prev-key prev-key
                  :prev-content prev-content})
          (js/setTimeout #(swap! state dissoc :changing? :prev-content) 210))))
    :reagent-render
    (fn [{:keys [content/key content]}]
      (let [{:keys [state]} (r/current-component)
            {:keys [changing?
                    prev-content
                    prev-key
                    enter-from]} @state
            changing? (and changing? (not= prev-key key))
            enter-from (when changing? enter-from)]
        [:div.h-slider--visible-frame.flex-auto.flex.items-stretch
         {:key "h-slider"}
         [:div.h-slider--content-container.modal--close-target.flex-none.flex
          {:style {:transition (str " 0.2s height ease"
                                    (when changing? ", 0.2s ease margin-left"))
                   ;:padding-bottom "2rem"
                   ;:margin-bottom "-2rem"
                   :margin-left (str (if-not changing?
                                       -100
                                       (case enter-from
                                         :left 0
                                         :right -200
                                         -100)) "%")}}
          (for [[key content] [(if (and changing?
                                        (= :left enter-from))
                                 [(or key :left) content]
                                 [:left nil])
                               (if changing?
                                 [(or prev-key :center) prev-content]
                                 [(or key :center) content])
                               (if (and changing?
                                        (= :right enter-from))
                                 [(or key :right) content]
                                 [:right nil])]]
            [:div.h-slider--content-item
             {:key key}
             content])]]))}))
